import { render, staticRenderFns } from "./detailImportFinanceTables.vue?vue&type=template&id=4914703c&scoped=true&"
import script from "./detailImportFinanceTables.vue?vue&type=script&lang=js&"
export * from "./detailImportFinanceTables.vue?vue&type=script&lang=js&"
import style0 from "./detailImportFinanceTables.vue?vue&type=style&index=0&id=4914703c&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4914703c",
  null
  
)

export default component.exports